import { Button, Flex } from "antd";
import { IconArrowNarrowLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router";
import { WorkspaceCheckerHide } from "./WorkspaceChecker";
import React from "react";

const PageHeader = ({
  title,
  description,
  backBtn,
  backRoute,
  additionalButton,
  bottomMargin = true,
}: {
  title?: string | React.ReactNode;
  description?: string;
  backBtn: boolean;
  /** When set, back navigates here instead of browser history */
  backRoute?: string;
  bottomMargin?: boolean;
  additionalButton?: {
    name: string;
    route: string;
    fn?: () => void;
    type?: "default" | "link" | "text" | "primary" | "dashed" | undefined;
  }[];
}) => {
  const navigate = useNavigate();

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        wrap={"wrap"}
        gap={12}
        className={`${bottomMargin ? "mb-[20px]" : ""}`}
      >
        <div className="flex items-center gap-24 mb-24">
          {backBtn && (
            <Button
              variant="filled"
              color="default"
              shape="circle"
              size="small"
              className="!border mt-[2px] shrink-0"
              onClick={() => (backRoute ? navigate(backRoute) : navigate(-1))}
              icon={<IconArrowNarrowLeft size={15} />}
            />
          )}
          <div>
            {title && (
              <h2 className="ds-page-header-title ff-title">{title}</h2>
            )}
            {description && (
              <p className="ds-page-header-desc">{description}</p>
            )}
          </div>
        </div>

        <WorkspaceCheckerHide
          showOnCompleted={title === "Payouts" ? true : false}
        >
          <div className="flex gap-[8px] flex-wrap">
            {additionalButton && additionalButton?.length > 0 ? (
              additionalButton.map(({ name, route, type, fn }, index) => (
                <Button
                  key={index}
                  type={type}
                  size="small"
                  onClick={() => {
                    if (route) navigate(route);
                    if (fn) fn();
                  }}
                >
                  {name}
                </Button>
              ))
            ) : (
              <></>
            )}
          </div>
        </WorkspaceCheckerHide>
      </Flex>
    </>
  );
};

export default PageHeader;
